<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :ignoreMaxTableItemLimit="true"
                                         @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPrResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
							<em-table :entity="modelName" withCustomRowActions ref="emTable" :inlineActionsDisabled="prop_inline!=='1'" :ignoreMaxTableItemLimit="true"
							 @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow" @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
								<template #customRowActions="{row}">
									<b-button-group>
										<em-button type="gotoParentMaterial" v-bind:class="'btn btn-outline-primary btn-sm'" @click="getParentMaterial(row)">
										</em-button>
										<em-button type="gotoChildMaterial" v-bind:class="'btn btn-outline-primary btn-sm'" @click="getChildMaterial(row)">
										</em-button>
									</b-button-group>
								</template>
							</em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author Shi Wen Long
    // Date 2021-07-01 11:38:11

    import emCommonListMixin from "@/mixin/em/common/list";
	import emCommonApiMixin from "@/mixin/em/common/api";

    export default {
        name: "sithMesStoolPrListView",
		mixins: [emCommonListMixin,emCommonApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
		},
		methods: {
			getParentMaterial(row) {
			    let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/findParentMaterialPr";
                this.$_emApiMixin_post(url, row)
                    .then(response => {
                      this.$refs['emTable'].$_emCustomVuexMixin_voStore = response.data;
                    })
			},
			getChildMaterial(row) {
                let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPr/findChildMaterialPr";
                    this.$_emApiMixin_post(url, row)
                    .then(response => {
                          console.log("返回的数据：" + response.data)
                          this.$refs['emTable'].$_emCustomVuexMixin_voStore = response.data;
                    }
                )
			},
        },
        mounted(){
            this.$refs["emListFilter"].doQuery();
        }
    };
</script>